import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail-+++",
  "use": "icon-detail-+++-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"icon-detail-+++\"><defs><style>#icon-detail-+++ .a{fill:#ccc;}</style></defs><g transform=\"translate(-540 -1152)\"><rect class=\"a\" width=\"21\" height=\"1\" transform=\"translate(540 1162)\" /><rect class=\"a\" width=\"21\" height=\"1\" transform=\"translate(551 1152) rotate(90)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/detail-+++.svg
// module id = nemq
// module chunks = 82